import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { profileService } from '../Services/profile.service';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-change-email',
  imports: [TranslateModule, CommonModule, ToasterComponent, ReactiveFormsModule],
  templateUrl: './change-email.component.html',
  styleUrl: './change-email.component.css'
})
export class ChangeEmailComponent {

  errorMessage: string | null = null;
  EmailForm!: FormGroup;
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  @Output() emailChanged = new EventEmitter<void>();
  @Input() currentEmail!: string;
  isCheckingEmail = false;
  isSentCode: boolean = false;



  private fb = inject(FormBuilder);
  private translate = inject(TranslateService)

  private profileService = inject(profileService);
  private cdr = inject(ChangeDetectorRef);

  selectedNationalIdFrontPath!: File | null;
  selectedNationalIdBackPath!: File | null;
  selectedPassportImagePath!: File | null;
  previewUrl1: string | ArrayBuffer | null = null;
  previewUrl2: string | ArrayBuffer | null = null;
  previewUrl3: string | ArrayBuffer | null = null;
  previewUrl4: string | ArrayBuffer | null = null;
  selectedCountry: any = "";


  ngOnInit(): void {
    this.EmailForm = this.fb.group({
      currentEmail: ['', Validators.required],
      newEmail: ['', [Validators.required, Validators.pattern(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)]],
      verificationCode: ['', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern(/^[0-9]+$/),
      ],],
    });
    this.checknewEmailReady()
  }


  ngOnChanges() {
    if (this.currentEmail) {
      this.EmailForm.patchValue({
        currentEmail: this.currentEmail
      });
    }
    // console.log("this.currentEmail", this.currentEmail)
  }

  checknewEmailReady() {
    this.EmailForm.get('newEmail')?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter((email) => {
        const control = this.EmailForm.get('newEmail');

        return !!control?.value &&
          control.valid &&
          !this.isCheckingEmail &&
          email !== this.currentEmail;
      })
    ).subscribe((email) => {

      this.isCheckingEmail = true;

      this.profileService.SendCodeOfChangeEmail(email).subscribe({
        next: (response: any) => {
          if (response.succeeded) {
            this.toastType = 'success';
            this.toastMessage = this.translate.instant('CONFIRMATION.SUCCESS_SEND_CODE');
            this.showToast = true;
            this.isSentCode = true;
            this.cdr.detectChanges();
            setTimeout(() => this.showToast = false, 3000);
            if (response.exists) {
              this.EmailForm.get('newEmail')?.setErrors({
                alreadyExists: true
              });
            }

            this.isCheckingEmail = false;
          }
          else {
            // console.log("response", response.errors[0])
            this.isSentCode = false;
            this.isCheckingEmail = false;
            this.toastType = 'error';
            this.toastMessage = response.errors[0];
            this.showToast = true;
            this.cdr.detectChanges();
            setTimeout(() => this.showToast = false, 3000);

          }
        },

        error: (err) => {
          // console.log("err", err)
          this.isSentCode = false;
          this.isCheckingEmail = false;
          this.toastType = 'error';
          this.toastMessage = err.error;
          this.showToast = true;
          this.cdr.detectChanges();
          setTimeout(() => this.showToast = false, 3000);

        }
      });

    });

  }


  onSubmit(): void {
    // console.log("submit")
    this.EmailForm.markAllAsTouched();
    if (this.EmailForm.valid) {
      // console.log("done")
      const sub = this.profileService.changeEmail({
        currentEmail: this.EmailForm.get("currentEmail")?.value,
        newEmail: this.EmailForm.get("newEmail")?.value,
        verificationCode: this.EmailForm.get("verificationCode")?.value,
      }).subscribe({
        next: (response: any) => {
          if (response.succeeded) {
            this.toastType = 'success';
            this.toastMessage = this.translate.instant('CONFIRMATION.SUCCESS_CONFIRM_EMAIL');
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
            this.EmailForm.reset({
              currentEmail: this.currentEmail,
              newEmail: '',
              verificationCode: ''
            });
            this.isSentCode = false
            this.emailChanged.emit();
            this.closeMembershipModal2()
            this.cdr.detectChanges()
          } else {
            // لو success=false ممكن تعرض رسالة خطأ
            this.toastType = 'error';
            // console.log("response.errors", response.errors[0])
            this.toastMessage = response.errors[0];
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
            this.cdr.detectChanges()
          }
        },
        error: () => {
          this.toastType = 'error';
          this.toastMessage = this.translate.instant('CONFIRMATION.ERROR');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      });
    }
  }

  closeMembershipModal2() {
    // const modalElement = document.getElementById('changeEmail');

    // if (modalElement) {
    //   const modalInstance = bootstrap.Modal.getInstance(modalElement);

    //   if (modalInstance) {
    //     modalInstance.hide();
    //   }

    // }
    this.closeMembershipModal()
  }

  closeMembershipModal() {
    // console.log("close")
    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }

  get f() {
    return this.EmailForm.controls;
  }

}
